export const selectInput = (array, key, value) => {
  let newArray = [];
  array.map((item) => {
    const x = {
      value: item[key],
      label: item[value],
    };
    return newArray.push(x);
  });

  return newArray;
};

export const selectValueFormat = (value) => {
  if (!value) return null;
  return { value: value, label: value };
};

export const formatAId = (aId) => {
  return aId.match(/.{1,3}/g).join("-");
};

export const uppercaseFirstLetter = (input) => {
  const formatedInput = input?.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
  return formatedInput;
}
export const capitalizeAllWords=(str)=> {
  return str?.toUpperCase()
}
export const formatPhoneNumber = (number) => {
  let formatedNumber = number;
  if (formatedNumber.startsWith("0")) {
    formatedNumber = number.replace("0", "");
    return formatedNumber
  }
  else {
    return formatedNumber
  }
};

export const phoneNumberIsValid = ({ countryCode, number }) => {
  let regex = new RegExp(/^[+]{1}(?:[0-9\-\(\)\/\.]\s?){9,15}[0-9]{1}$/);
  return regex.test(countryCode + number);
}

export const cutWords = (word, num) => {
  let cutNumber = num || 10;
  if (word && word.length > cutNumber) {
    return word.slice(0, cutNumber) + "...";
  } else {
    return word;
  }
};

export const emailIsInvalid = (email) => {
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  if (email !== null && email.match(emailRegex) === null) {
    return true;
  } else {
    return false;
  }
};

export const formatDate = (inputDate) => {
  if (!inputDate) return "";
  const date = new Date(inputDate);
  const yyyy = date.getFullYear();
  let mm = date.getMonth() + 1;
  let dd = date.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedDate = dd + "/" + mm + "/" + yyyy;
  return formattedDate;
};

export const longDateformat = (inputDate) => {
  const date = new Date(inputDate);
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  return day + " " + monthNames[monthIndex] + " " + year;
};
export const renderTodayOrYesterday = (date) => {
  const currentDate = new Date();
  const givenDate = new Date(date);
  const isToday =
    givenDate.getDate() === currentDate.getDate() &&
    givenDate.getMonth() === currentDate.getMonth() &&
    givenDate.getFullYear() === currentDate.getFullYear();

  const isYesterday =
    givenDate.getDate() === currentDate.getDate() - 1 &&
    givenDate.getMonth() === currentDate.getMonth() &&
    givenDate.getFullYear() === currentDate.getFullYear();

  if (isToday) {
    return <span> Today, {givenDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} </span>;
  } else if (isYesterday) {
    return <span> Yesterday, {givenDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>;
  } else {
    return <span>{givenDate.toDateString()} {","} {givenDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
    </span>;
  }
}

export const formatDateToAPI = (inputDate) => {
  if (!inputDate) return "";
  let [d, m, y] = inputDate.split("/");
  if (+d < 10) d = "0" + +d;
  if (+m < 10) m = "0" + +m;
  return `${y}-${m}-${d}`;
};

export const formatDateFromAPI = (inputDate) => {
  if (!inputDate) return "";
  let [y, m, d] = inputDate.split("-");
  if (+d < 10) d = "0" + +d;
  if (+m < 10) m = "0" + +m;
  return `${d}/${m}/${y}`;
};
export const calculateStaerAndEndDate = (status) => {
  let startDate = new Date();
  let endDate = new Date();
  if (status === "lastweek") {
    startDate.setDate(startDate.getDate() - startDate.getDay() - 6);
    startDate.setHours(0, 0, 0, 0);
    endDate.setDate(startDate.getDate() + 6);
    endDate.setHours(23, 59, 59, 999);
  } else if (status === "lastmonth") {
    startDate.setMonth(startDate.getMonth() - 1);
    startDate.setDate(1);
    startDate.setHours(0, 0, 0, 0);
    endDate.setMonth(startDate.getMonth() + 1);
    endDate.setDate(0);
    endDate.setHours(23, 59, 59, 999);
  } else if (status === "lastyear") {
    startDate.setFullYear(startDate.getFullYear() - 1);
    endDate.setFullYear(endDate.getFullYear() - 1);
    startDate.setDate(1);
    startDate.setMonth(0);
    startDate.setHours(0, 0, 0, 0);
    endDate.setMonth(11);
    endDate.setDate(31);
    endDate.setHours(23, 59, 59, 999);
  } else if (status === "thisweek") {
    startDate.setDate(startDate.getDate() - startDate.getDay());
    startDate.setHours(0, 0, 0, 0);
    endDate.setDate(startDate.getDate() + 6);
    endDate.setHours(23, 59, 59, 999);
  } else if (status === "thismonth") {
    startDate.setDate(1);
    startDate.setHours(0, 0, 0, 0);
    endDate.setMonth(startDate.getMonth() + 1);
    endDate.setDate(0);
    endDate.setHours(23, 59, 59, 999);
  } else if (status === "thisyear") {
    startDate.setMonth(0);
    startDate.setDate(1);
    startDate.setHours(0, 0, 0, 0);
    endDate.setMonth(11);
    endDate.setDate(31);
    endDate.setHours(23, 59, 59, 999);
  }
  startDate = formatDate(startDate);
  endDate = formatDate(endDate);
  return { startDate, endDate };
}
export const valueNull = (value) => {
  if (!value && value !== 0) return "____";
  else return value;
};

export const formatTime = (inputDate) => {
  const time = new Date(inputDate).toLocaleTimeString("en", {
    timeStyle: "short",
    hour12: true,
    timeZone: "UTC",
  });
  return time;
};

export const shortenString = (str, maxLength) => {
  if (str.length <= maxLength) {
    return str;
  }
  return str.substring(0, maxLength - 3) + "...";
};

export const shortenDateTime = (dateTimeString) => {
  const date = new Date(dateTimeString);
  const time = date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
  return time;
};
export const truncateUrl = (url) => {
  const maxLength = 20;
  if (url.length <= maxLength) {
    return url;
  }
  const truncatedUrl = url.slice(0, maxLength) + "...";
  return truncatedUrl;
};


export const formatDateAndTime = (inputDate) => {
  var newDate = new Date(inputDate);

  var sMonth = padValue(newDate.getMonth() + 1);
  var sDay = padValue(newDate.getDate());
  var sYear = newDate.getFullYear();
  var sHour = newDate.getHours();
  var sMinute = padValue(newDate.getMinutes());
  var sAMPM = "AM";

  var iHourCheck = parseInt(sHour);

  if (iHourCheck > 12) {
    sAMPM = "PM";
    sHour = iHourCheck - 12;
  }
  else if (iHourCheck === 0) {
    sHour = "12";
  }

  sHour = padValue(sHour);

  return sDay + "/" + sMonth + "/" + sYear + " " + sHour + ":" + sMinute + " " + sAMPM;
}

function padValue(value) {
  return (value < 10) ? "0" + value : value;
}

export const formatAMPM = (inputDate) => {
  const date = new Date(inputDate);
  date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
  const time = date.toLocaleString([], {
    hour: '2-digit',
    minute: '2-digit'
  });
  return time
}

export const compareDates = (date, timeSlot) => {
  const dateParts = date.split("/");
  let mainDate = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
  let todaysDate = new Date();
  if (mainDate.setHours(0, 0, 0, 0) === todaysDate.setHours(0, 0, 0, 0)) {
    let inputDate = new Date(timeSlot)
    inputDate.setMinutes(inputDate.getMinutes() + inputDate.getTimezoneOffset())
    const inputTime = inputDate.toLocaleString([], {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit'
    });
    const currentTime = new Date().toLocaleString([], {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit'
    });

    if (inputTime <= currentTime) {
      return true
    }
    else {
      return false
    }
  }
  else {
    return false
  }
}

//[{label: 1, value: 1} ]==> [1]
export const convertSelectIntoArr = (arr) => {
  return arr?.map((obj) => {
    return obj?.value;
  });
};

//[1] ==> [{label: 1, value: 1}]
export const convertArrIntoSelect = (arr) => {
  return arr?.map((obj) => {
    return { label: obj, value: obj };
  });
};

export const isValidEmail = (email) => {
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  return emailRegex.test(email);
};

export const getNextDate = (date) => {
  let d = new Date(formatDateToAPI(date));
  d.setDate(d.getDate() + 1);

  let year = d.getFullYear()
  let month = String(d.getMonth() + 1)
  let day = String(d.getDate())

  month = month.length === 1 ?
      month.padStart('2', '0') : month;

  day = day.length === 1 ?
      day.padStart('2', '0') : day;

  return `${year}-${month}-${day}`
}

export const dateDiffInDays = (date1, date2) => {
  // Convert both dates to UTC
  const [day1, month1, year1] = date1.split('/');
  const [day2, month2, year2] = date2.split('/');

  // Create Date objects using the parsed values (subtract 1 from month since it's zero-based)
  const utcDate1 = new Date(Date.UTC(year1, month1 - 1, day1));
  const utcDate2 = new Date(Date.UTC(year2, month2 - 1, day2));

  // Calculate the difference in milliseconds
  const diffInMs = utcDate2 - utcDate1;

  // Convert the difference from milliseconds to days
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  return diffInDays;
}

export const calcDiffrenceTime = (time1, time2) => {
  const time1Arr = time1.split(":");
  const time2Arr = time2.split(":");
  const time1Hours = time1Arr[0];
  const time1Minutes = time1Arr[1];
  const time2Hours = time2Arr[0];
  const time2Minutes = time2Arr[1];
  const time1InMinutes = parseInt(time1Hours) * 60 + parseInt(time1Minutes);
  const time2InMinutes = parseInt(time2Hours) * 60 + parseInt(time2Minutes);
  const diffrence = time2InMinutes - time1InMinutes;
  return diffrence;
}

export const isDarkColor = (color) => {
  const rgb = color.match(/\d+/g);
  if (!rgb) return false;
  const [r, g, b] = rgb.map(Number);
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  const threshold = 128;
  return luminance < threshold;
}

export const ConvertToArabicNumbers = (num) => {
  const arabicNumbers = '\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669';
  return num.toString().replace(/[0123456789]/g, (d) => { return arabicNumbers[d] });
}

export const convertNumbers2English = (string) => {
  return string.replace(/[\u0660-\u0669]/g, function (c) {
    return c.charCodeAt(0) - 0x0660;
  }).replace(/[\u06f0-\u06f9]/g, function (c) {
    return c.charCodeAt(0) - 0x06f0;
  });
}

export const validWordsWithLang = (word, lang) => {
  const arabicPattern = /[\u0600-\u06FF]/.test(word)
  if(arabicPattern && lang === "ar"){
    return true
  } else {
    if (!arabicPattern && lang !== "ar"){
      return true
    } else {
      return false
    }
  }
}
